import { type ReactNode, useMemo } from 'react'

import {
  destroyClient as destroyAnalyticsClient,
  getClient as getAnalyticsClient,
} from '@mondough/analytics-v2'
import type { ConsentCookieOptions } from '@mondough/consent-management/core'
import { useAsyncConsentEffect } from '@mondough/consent-management/react'
import { CookieConsentUI } from '@mondough/consent-management/ui'
import { getEnv } from '@mondough/next-utils'

import { COOKIES_EXPIRY_DATE_IN_DAYS, setupAnalytics } from '../../utils'

const baseUrl = () =>
  new URL(
    typeof window === 'undefined' ? getEnv('baseUrl') : window.location.href,
  )
const cookieOptions = (): ConsentCookieOptions => {
  const { hostname, protocol } = baseUrl()
  return {
    domain: hostname,
    secure: protocol === 'https:',
    maxAge: 60 * 60 * 24 * COOKIES_EXPIRY_DATE_IN_DAYS,
  }
}

export function ConsentManagement({ children }: { children: ReactNode }) {
  const options = useMemo(cookieOptions, [])
  return (
    <CookieConsentUI
      initialCookie={() =>
        typeof document !== 'undefined' ? document.cookie : null
      }
      cookieOptions={options}
      persistCookieToDocument
    >
      <AnalyticsWrapper>{children}</AnalyticsWrapper>
    </CookieConsentUI>
  )
}

function AnalyticsWrapper({ children }: { children: React.ReactNode }) {
  useAsyncConsentEffect('analytics', async () => {
    if (!getAnalyticsClient()) {
      await setupAnalytics()
    }
    return destroyAnalyticsClient
  })

  return <>{children}</>
}
